import React, { useCallback, useMemo, useState, memo } from "react";
import {
  Autocomplete,
  Button,
  Dialog,
  DialogContent,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";
import {
  Box,
  MenuItem,
  Select,
  TextField,
  styled,
  Typography,
  ListItemText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  addItem,
  addTabItem,
  applyDiscount,
  editItem,
  editMultiItems,
  increaseSaleQty,
  removeItem,
} from "./saleSlice";
import { Toast } from "../components/Toast";
import dustbin from "../../images/dustbin.png";
import { SubTitle } from "./styles";
import { RFTfeature } from "../features/RFTfeature";
import AddDiscount from "./AddDiscount";
import { getItemDiscount } from "../../utils/getItemDiscount";
import { BoxesPacking } from "../features/BoxesPacking";
import { ClipLoader } from "react-spinners";
import BarcodeReader from "react-barcode-reader";
import DefaultRepository from "../../Repository/DefaultRepository";
import DialogComponent from "../reusableComponents/Dialog";
import AddItem from "../inventory/AddItem";
import { useMediaQuery, useTheme } from "@mui/material";
import { saleQuantity } from "../inventory/itemsSlice";
let company_code = localStorage.getItem("companyCode");

const RowBox = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "35% 10% 10% 10% 15% 15% 5%",
  borderRadius: "8px",
  background: "#fff",
  color: "black",
  boxShadow: "0px 3px 6px #c2c1c1",
  margin: "8px 0",
  [theme.breakpoints.down("md")]: {
    gridTemplateColumns: "55% 23% 22%",
  },
}));

const Row = memo(
  ({
    item,
    i,
    units,
    inventory,
    handleEdit,
    handleItem,
    handleRemove,
    handleSalePrice,
    isMdDown,
    state,
    dispatch,
    // batchPriceCalculator
  }) => {
    console.log("stteee", state);
    console.log("itemssssssss", item);

    console.log(
      "salePrice:",
      item.salePrice,
      "costPrice:",
      item.costPrice,
      "priceComparison:",
      item.priceComparison
    );

    const itemDiscount = item.saleDiscount ?? item.discount ?? 0;
    const saleQuantity = item.saleQuantity ?? 1;
    const pr = item.salePrice ?? item.price ?? 0;
    console.log('prrrrrrrrr',pr)
    const customFilterOptions = (options, state) => {
      const inputValue = state.inputValue.toLowerCase();
      console.log("options", options);
      // First filter options that start with the input value
      // const batchSearch = options?.filter((option) =>
      //   option?.batchNumber[0]?.batchNumber?.toString().startsWith(inputValue)
      // );
      // console.log("batchSearch", batchSearch);
      const codeSearch = options.filter(
        (option) =>
          inputValue && option?.itemId?.toString().startsWith(inputValue)
      );

      console.log("codeSearch", codeSearch);
      const startsWith = options.filter((option) =>
        option.name.toLowerCase().startsWith(inputValue)
      );
      console.log("startswith", startsWith);
      // Then filter options that contain the input value
      const contains = options?.filter(
        (option) =>
          (option.name?.toLowerCase().includes(inputValue) &&
            !option.name?.toLowerCase().startsWith(inputValue))
             ||
          option?.itemId?.toString().startsWith(inputValue) ||
          Array.isArray(option?.batchNumber) &&
          option.batchNumber[0]?.batchNumber?.toString().startsWith(inputValue)
             ||
          option.name.toLowerCase().startsWith(inputValue) 
          ||
          option?.imeiNumber?.toLowerCase().startsWith(inputValue)

      );
      console.log("contains", contains);
      const arr = [...contains, ];
      console.log("arr", arr);
      // Combine both, prioritizing startsWith first
      return arr;
    };

    
    const batchPriceCalculator = () => {
      const price = item?.batchNumber?.reduce((acc, curr) => {
        console.log('curr', curr);
        // Safely accumulate the prices
        return acc + (Number(curr?.newItem?.price) || 0);
      }, 0); // Start with 0 as the initial value for acc
    
      console.log('pricceee', price);
      return price; // Return the total price
    };
    let TotalPrice;

    const pricePerBoxHandler = () => {
      let calculatedPrice;
      if(item.saleType == "pieces" && item.pricePerPiece){
        calculatedPrice =  Number(item.pricePerPiece);
        console.log("priceperbox", calculatedPrice);
      }
      else if(item.saleType == "pieces") {
        calculatedPrice = Number(pr) / Number(item.piecesPerBox);
        console.log("priceperbox", calculatedPrice);
      } else {
        return (calculatedPrice = pr);
      }
      console.log("calcualtedPrice", calculatedPrice);
      return calculatedPrice;
      //   return parseInt(calculatedPrice);
      // }, [pr, item.piecesPerBox,item.saleType,TotalPrice,item.saleDiscount, item.salePrice, item.price, item.saleQuantity,]);
    };
    console.log("", item);
    TotalPrice = useMemo(() => {
      let itemPrice =Number(item.batchPricePerBox ? Number(item.batchPricePerBox) : Number((item.salePrice ? item.salePrice : item.price)));
      let saleQtyy = Number(item.saleQuantity ? item.saleQuantity : 1);
      console.log("itemPrice", itemPrice);
      const pricePerBox = pr / item.piecesPerBox;

      if (item.saleDiscount) {
        const itemDiscountPrice = (itemPrice / 100) * item.saleDiscount;
        const priceAfterDiscountPerUnit = itemPrice - itemDiscountPrice;
        return priceAfterDiscountPerUnit * item.saleQuantity;
      } else {
        console.log("itemsale", item.saleQuantity);
        return (
          (item.saleType == "pieces" ?( pricePerBoxHandler() || item.batchPricePerPiece) : itemPrice) *
          saleQtyy
        );
      }
    }, [
      item.saleDiscount,
      item.salePrice,
      item.price,
      item.saleQuantity,
      item.saleType,
      pr,
      item.saleBatchNumber,
      item.batchPricePerPiece,
      item.pricePerPiece
    ]);

    return (
      <Box sx={{ background: "#fff" }}>
        <RowBox
          key={i}
          sx={
            {
              //           display: "grid",
              //           gridTemplateColumns: {
              //   xs: item.saleType === "pieces" ? "55% 23% 22% " : "55% 23% 22%",
              //   md: item.saleType === "pieces" ? "35% 10% 10% 10% 15% 15% " : "35% 10% 10% 10% 15% 15% 5%",
              // },
            }
          }
        >
          {/* xs: item.bonus == "pieces" ? "55% 23% 22% 55%" : "55% 23% 22%", // Example for extra-small screens (you can adjust this as needed)
md: item.bonus == "pieces" ? "35% 10% 10% 10% 15% 15% 5% 35%" : "35% 10% 10% 10% 15% 15% 5%",  */}
          <Autocomplete
            size="small"
            fullWidth
            value={item}
            onChange={(e, val) => {
              handleItem(e, val);
            }}
            getOptionLabel={(option) => option?.name || ""}
            id="controllable-states-demo"
options={inventory}
            filterOptions={customFilterOptions}
            renderInput={(params, item) => (
              // renderInput={(props, item) => (
              <TextField
                placeholder={isMdDown ? "Select An Item" : ""}
                {...params}
                // {...props}
                fullWidth
                variant="outlined"
                size="small"
              />
            )}
            renderOption={(props, item) => (
              <li {...props} key={item.key}>
                <ListItemText>{item.name}</ListItemText>
              </li>
            )}
          />

          <TextField
            type="number"
            size="small"
            value={itemDiscount}
            onChange={(e) => handleEdit(e, i, "saleDiscount")}
            placeholder={isMdDown ? "Disc" : ""}
            disabled={!item._id}
          />

          <TextField
            type="number"
            size="small"
            disabled={!item._id}
            max={item?.quantity}
            sx={{ mx: "2px" }}
            value={item._id ? saleQuantity : ""}
            onChange={(e) =>
              handleEdit(e, i, "saleQuantity", item?.steelWeightKg)
            }
            placeholder={isMdDown ? "Qty" : ""}
          />

          <Select
            variant="outlined"
            disabled={!item._id}
            value={item?.unit || ""}
            name="unit"
            size="small"
            displayEmpty
            onChange={(e) => handleEdit(e, i, "unit")}
          >
            <MenuItem value="">
              <em>{isMdDown ? "Select unit" : ""}</em>
            </MenuItem>
            {units?.map((unit, ind) => (
              <MenuItem key={ind} value={unit}>
                {unit}
              </MenuItem>
            ))}
          </Select>

          <TextField
            placeholder={isMdDown ? "Price" : ""}
            type="number"
            size="small"
            disabled={!item._id}
           
            value={
             (item.saleType == "box" && item.batchPricePerBox)
                ? Number(item.batchPricePerBox)
                :
                 Number((item.saleType === "pieces" ? item.pricePerPiece : pr) || item.batchPricePerPiece)
            }
           
            onClick={(e) =>
              handleSalePrice(e.target.value, i, item?.costPrice, item.saleType)
            }
            // onChange={(e) => handleEdit(e, i, "salePrice")}
            onChange={(e) => handleEdit(e, i, "salePrice", item.saleQuantity,item.quantity)}
          />

          <TextField
            placeholder={isMdDown ? "Total" : ""}
            size="small"
            disabled
            value={
              TotalPrice % 1 === 0
                ? TotalPrice
                : parseFloat(TotalPrice).toFixed(3) || 0
            }
          />
          {/* {item.saleType == "pieces" ? (
            <TextField
              placeholder={isMdDown ? "Price Per Piece" : ""}
              size="small"
              disabled
              value={pricePerBoxHandler() || 0}
            />
          ) : (
            ""
          )} */}

          {item?._id && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <img
                height="25px"
                style={{ cursor: "pointer" }}
                src={dustbin}
                alt="img"
                onClick={() => handleRemove(item._id, i)}
              />
            </Box>
          )}
        </RowBox>
      </Box>
    );
  }
);

function TabOrderComponent({ state }) {
  const dispatch = useDispatch();
  const selectedForSale = useSelector((state) => state.sale.selected);
  console.log("selectedddd", selectedForSale);
  const inventory = useSelector((state) => state.inventory.items);
  const { units } = useSelector((state) => state.units);
  const [bonus, setBonus] = useState(false);
  const [saleType, setSaleType] = useState("sale");
  const [saleBy, setSaleBy] = useState("Role");
  const [discModal, setDiscModal] = useState(false);
  const [barCodeLoading, setBarCodeLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [barcode, setBarcode] = useState(false);

  const theme = useTheme();
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"));

  const HeadBox = styled(Box)({
    padding: "10px 8px",
    display: "grid",
    gridTemplateColumns: isMdDown
      ? "20% 13% 10% 10% 15% 15% 5%"
      : "35% 10% 10% 15% 10% 15% 5%",
    borderRadius: "8px",
    background: "#4daf51",
    color: "white",
  });

  const toggle = useCallback(() => {
    setAddModal((prev) => !prev);
  }, []);

  const discToggle = useCallback(() => {
    setDiscModal((prev) => !prev);
  }, []);

  const handleEdit = useCallback(
    (e, indx, key, pack,quantity) => {
      let value = e.target.value;
      console.log("valllllllll", value);
      console.log("indx", indx);
      console.log("pack", pack);
      console.log("quantity", quantity);


      // let selectedItem;
      // if(key == "saleQuantity") {
      //   selectedItem = selectedForSale[indx];
      //   console.log('selectedItem', selectedItem)

      //    if(selectedItem.saleQuantity > selectedItem.quantity ) {
      //   return Toast("info", `Cannot Sale More Quantity Then Stock ${selectedItem?.name} `);
     
      // }
      // }

      // if (key === "salePrice" && pack > quantity) {
      //   return Toast("info", `Cannot Sale More Quantity Than Stock: ${pack.name}`);
      // }
  

      console.log("key", key);
      console.log("selectedForSale", selectedForSale);

      let steelWeightKgSale;
      if (pack) {
        steelWeightKgSale = Number(value) * Number(pack);
      }
      dispatch(
        editItem({
          index: indx,
          key: key,
          value: value,
          packValue: steelWeightKgSale,
        })
      );
    },
    [dispatch]
  );

  const handleItem = useCallback(
    (e, val) => {
      // if(val.quantity <= 0 ) {
      //   return Toast("info", `${val?.name}Quantity Is ${val?.quantity}`);
     
      // }

      // if(val.saleQuantity > val.quantity ) {
      //   return Toast("info", `Cannot Sale More Quantity Then Stock ${val?.name} `);
     
      // }

      console.log("addval", val);
      if (val) {
        const newVal = {
          ...val,
          saleQuantity: 1,
          saleType: "box",
        };

        console.log("add", newVal);
        dispatch(addTabItem(newVal));
      }
    },
    [dispatch]
  );

  const handleRemove = useCallback(
    (_id, index) => {
      console.log("id", _id);
      console.log("index", index);

      dispatch(removeItem({ index: index, _id: _id }));
    },
    [dispatch]
  );

  const handleSalePrice = useCallback(
    (val, i, price, saleType) => {
      if (saleType !== "pieces") {
        if (parseFloat(val) < parseFloat(price)) {
          Toast("info", "Sale price cannot be less than cost price");
          dispatch(editItem({ index: i, key: "salePrice", value: price }));
        }
      }
    },
    [dispatch]
  );

  const handleBonus = useCallback((e) => {
    setBonus(e.target.checked);
  }, []);

  const getTotalPrice = useCallback((item) => {
    let salePrice = item?.salePrice ? item?.salePrice : item?.price || 0;
    let total = 0;
    if (item.saleQuantity) {
      total = Math.ceil(salePrice * item?.saleQuantity - getItemDiscount(item));
    } else {
      if (salePrice) {
        total = salePrice;
      }
    }
    return total;
  }, []);

  const fetchBarCode = async (value) => {
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "getItemByBarCode",
        data: {
          company_code: localStorage.getItem("companyCode"),
          barCode: value,
        },
      },
    });
    let item = data.response.data.item;
    if (data.response.data.item) {
      item.saleQuantity = 1;
      dispatch(addItem(item));
    } else {
      Toast("info", "Item Not Found");
    }
    setBarCodeLoading(false);
  };


  const scanItem = useCallback(
    (value) => {
      console.log("dis", value);
      setBarCodeLoading(true);
      let found = "";
      let serverFound = "";
      found = inventory.find((item) => item?.barCode == value);
      if (found) {
        setBarcode(true);
      }

      if (found) {
        setBarCodeLoading(false);
        dispatch(increaseSaleQty(found));
      } else {
        serverFound = inventory.find((item) => item?.barCode == value);

        if (serverFound) {
          setBarCodeLoading(false);
          dispatch(increaseSaleQty(serverFound));
        } else {
          fetchBarCode(value);
        }
      }
    },
    [dispatch, inventory]
  );

  const handleOnScan = useCallback(
    (e) => {
      if (!barCodeLoading) {
        scanItem(e);
      }
    },
    [barCodeLoading, scanItem]
  );

  const handleError = useCallback((err) => {
    console.log("err");
  }, []);

  return (
    <Box sx={{ p: 2 }}>
      <BarcodeReader onScan={handleOnScan} onError={handleError} />
      <Box sx={{ my: "8px", display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {selectedForSale.length > 0 && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Button
                variant="contained"
                sx={{ textTransform: "none" }}
                onClick={discToggle}
              >
                Group Discount
              </Button>

              <input
                style={{ padding: 0, marginRight: "5px", marginLeft: "10px" }}
                type="checkbox"
                className="regular"
                checked={bonus}
                onChange={handleBonus}
              />

              <Typography sx={{ ml: "8px" }}>Bonus</Typography>
            </Box>
          )}
        </Box>

        <Button sx={{ ml: 5 }} variant="contained" onClick={toggle}>
          Add Item
        </Button>
      </Box>
      <HeadBox>
        <SubTitle>Item</SubTitle>
        <SubTitle>Disc%</SubTitle>
        <SubTitle>Sale Qty</SubTitle>
        {company_code == "8553" ? (
          <SubTitle>Size</SubTitle>
        ) : (
          <SubTitle>Unit</SubTitle>
        )}
        <SubTitle>U.Price</SubTitle>
        <SubTitle>Total</SubTitle>
        <SubTitle>Action</SubTitle>
      </HeadBox>
      {[...selectedForSale, {}].map((item, i) => {
        // let itemPrice = item.price ? item.price : item.salePrice
        console.log("selected", item);
        return (
          <Box>
            <Row
              item={item}
              i={i}
              units={units}
              inventory={inventory}
              handleEdit={handleEdit}
              handleItem={handleItem}
              handleRemove={handleRemove}
              handleSalePrice={handleSalePrice}
              // TotalPrice={TotalPrice}
              dispatch={dispatch}
              isMdDown={isMdDown}
              state={state}
              // batchPriceCalculator={batchPriceCalculator}
            />

            {item?.box == true  && (
              <FormControl sx={{ width: { md: "35%", xs: "22%" } }}>
                <InputLabel id="sale-type-label">Sale Type</InputLabel>
                <Select
                  labelId="sale-type-label"
                  id="sale-type"
                  value={item?.saleType}
                  label="Sale Type"
                  onChange={(e) => handleEdit(e, i, "saleType")}
                >
                  <MenuItem value="box">
                    {item.saleLabel == "box" ? "By Box" : "By Ctn"}
                  </MenuItem>
                  <MenuItem value="pieces">
                    {item.saleLabel == "box" ? "By Pieces" : "By Box"}
                  </MenuItem>
                </Select>
              </FormControl>
            )}
            {(item.steelWeightKg > 0 && (item.steelWeightKg !== 0 &&  item.steelWeightKg !== "0") ) && (
              <TextField
                value={Number(item?.steelWeightKg) * (item.saleQuantity || 1)}
                placeholder={isMdDown ? "Total" : ""}
                size="small"
                disabled
                label="Total Weight (Kg)" // Add a label
                // onChange={(e) => handleEdit(e, i, "steelWeightKgSale")}
              />
            )}
            {(Array.isArray(item?.batchNumber) && item.batchNumber.length > 0 )&&(
              <FormControl sx={{ width: { md: "35%", xs: "22%" } }}>
                <InputLabel id="sale-type-label">Batch Numbers</InputLabel>
                <Select
                  labelId="sale-type-label"
                  id="sale-type"
                  value={item?.batchValue}
                  label="Batch Numbers"
                  onChange={(e) => handleEdit(e, i, "saleBatchNumber")}
                >
                  {item.batchNumber.map((val, index) => {
                    return (
                      <MenuItem value={val}>
                        {val.batchNumber}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            )}
          </Box>
        );
      })}

      {discModal && <AddDiscount onClose={discToggle} />}

      <DialogComponent
        title="Add Item"
        open={addModal}
        onClose={toggle}
        dialogContent={<AddItem onClose={toggle} sale="true" />}
      />
    </Box>
  );
}

export default TabOrderComponent;

// import React, { useCallback, useMemo, useState } from "react";
// import {
//   Autocomplete,
//   Button,
//   Dialog,
//   DialogContent,
//   FormControl,
//   InputLabel,
//   Stack,
// } from "@mui/material";
// import {
//   Box,
//   MenuItem,
//   Select,
//   TextField,
//   styled,
//   Typography,
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   addItem,
//   addTabItem,
//   applyDiscount,
//   editItem,
//   editMultiItems,
//   increaseSaleQty,
//   removeItem,
// } from "./saleSlice";
// import { Toast } from "../components/Toast";
// import dustbin from "../../images/dustbin.png";
// import { SubTitle } from "./styles";
// import { RFTfeature } from "../features/RFTfeature";
// import AddDiscount from "./AddDiscount";
// import { getItemDiscount } from "../../utils/getItemDiscount";
// import { BoxesPacking } from "../features/BoxesPacking";
// import { ClipLoader } from "react-spinners";
// import BarcodeReader from "react-barcode-reader";
// import DefaultRepository from "../../Repository/DefaultRepository";
// import DialogComponent from "../reusableComponents/Dialog";
// import AddItem from "../inventory/AddItem";
// import { useMediaQuery, useTheme } from '@mui/material';

// function TabOrderComponent({ state }) {
//   const dispatch = useDispatch();
//   const selectedForSale = useSelector((state) => state.sale.selected);
//   const inventory = useSelector((state) => state.inventory.items);
//   const { units } = useSelector((state) => state.units);
//   const [bonus, setBonus] = useState(false);
//   const [saleType, setSaleType] = useState("sale");
//   const [saleBy, setSaleBy] = useState("Role");
//   const [discModal, setDiscModal] = useState(false);
//   const [barCodeLoading, setBarCodeLoading] = useState(false);
//   const [addModal, setAddModal] = useState(false);
//   const [barcode, setBarcode] = useState(false);
//   console.log('slectedforslae', selectedForSale)
//   const theme = useTheme();
//   const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

//   const RowBox = styled(Box)({
//     display: "grid",
//     gridTemplateColumns: isMdDown ? "55% 23% 22% " : "35% 10% 10% 15% 10% 15% 5%",
//     borderRadius: "8px",
//     background: "#4daf51",
//     color: "white",
//     boxShadow: "0px 3px 6px #c2c1c1",
//     margin: "8px 0",
//     background: "white",
//     color: "black",
//   });

//   const HeadBox = styled(Box)({
//     padding: "10px 8px",
//     display: "grid",
//     gridTemplateColumns:  isMdDown ?"15% 15% 15% 15% 15% 15% 5%" : "35% 10% 10% 15% 10% 15% 5%",
//     borderRadius: "8px",
//     background: "#4daf51",
//     color: "white",
//   });

//   const toggle = useCallback(() => {
//     setAddModal((prev) => !prev);
//   }, []);

//   const discToggle = useCallback(() => {
//     setDiscModal((prev) => !prev);
//   }, []);

//   const handleEdit = useCallback((e, indx, key, pack) => {
//     console.log('e',indx)
//     let value = e.target.value;
//     dispatch(editItem({ index: indx, key: key, value: value }));
//   }, [dispatch]);

//   const handleItem = useCallback((e, val) => {
//     if (val) {
//       dispatch(addTabItem(val));
//     }
//   }, [dispatch]);

//   const handleRemove = useCallback((_id, index) => {
//     dispatch(removeItem({ index: index, _id: _id }));
//   }, [dispatch]);

//   const handleSalePrice = useCallback((val, i, price) => {
//     console.log('valsale',val)

//     if (parseFloat(val) < parseFloat(price)) {
//       Toast("info", "Sale price cannot be less than cost price");
//       dispatch(editItem({ index: i, key: "salePrice", value: price }));
//     }
//   }, [dispatch]);

//   const handleBonus = useCallback((e) => {
//     setBonus(e.target.checked);
//   }, []);

//   const getTotalPrice = useCallback((item) => {
//     let salePrice = item?.salePrice ? item?.salePrice : item?.price || 0;
//     let total = 0;
//     if (item.saleQuantity) {
//       total = Math.ceil(salePrice * item?.saleQuantity - getItemDiscount(item));
//     } else {
//       if (salePrice) {
//         total = salePrice;
//       }
//     }
//     return total;
//   }, []);

//   const fetchBarCode = async (value) => {
//     let { data } = await DefaultRepository.defaultModel({
//       request: {
//         method: "getItemByBarCode",
//         data: {
//           company_code: localStorage.getItem("companyCode"),
//           barCode: value,
//         },
//       },
//     });
//     let item = data.response.data.item;
//     if (data.response.data.item) {
//       item.saleQuantity = 1;
//       dispatch(addItem(item));
//     } else {
//       Toast("info", "Item Not Found");
//     }
//     setBarCodeLoading(false);
//   };

//   const scanItem = useCallback((value) => {
//     setBarCodeLoading(true);
//     let found = "";
//     let serverFound = "";
//     found = inventory.find((item) => item?.barCode == value);
//     if(found) {
//       setBarcode(true);
//     }

//     if (found) {
//       setBarCodeLoading(false);
//       dispatch(increaseSaleQty(found));
//     } else {
//       serverFound = inventory.find((item) => item?.barCode == value);

//       if (serverFound) {
//         setBarCodeLoading(false);
//         dispatch(increaseSaleQty(serverFound));
//       } else {
//         fetchBarCode(value);
//       }
//     }
//   }, [dispatch, inventory]);

//   const handleError = useCallback((err) => {
//     console.log('err')
//   }, []);

//   const handleScan = useCallback((data) => {
//     scanItem(data);
//   }, [scanItem]);

//   return (
//     <Box>
//       <Box sx={{ my: "8px", display: "flex", justifyContent: "center" }}>
//         <Box sx={{ display: "flex", alignItems: "center" }}>
//           {selectedForSale.length > 0 && (
//             <Box sx={{ display: "flex", alignItems: "center" }}>
//               <Button
//                 variant="contained"
//                 sx={{ textTransform: "none" }}
//                 onClick={discToggle}
//               >
//                 Group Discount
//               </Button>

//               <input
//                 style={{ padding: 0, marginRight: "5px", marginLeft: "10px" }}
//                 type="checkbox"
//                 className="regular"
//                 checked={bonus}
//                 onChange={handleBonus}
//               />

//               <Typography sx={{ ml: "8px" }}>Bonus</Typography>
//             </Box>
//           )}
//         </Box>
//         <Box style={{ display: "flex", margin: "10px 0px" }}>
//           <BarcodeReader  onError={handleError}  onScan={handleScan} />
//           {barCodeLoading && (
//             <ClipLoader size={30} color={"#4DAF51"} loading={true} />
//           )}
//         </Box>
//       </Box>
//       <HeadBox>
//         <SubTitle>Item</SubTitle>
//         <SubTitle>Disc%</SubTitle>
//         <SubTitle>Sale Qty</SubTitle>
//         <SubTitle>Units</SubTitle>
//         <SubTitle>U.Price</SubTitle>
//         <SubTitle>Total</SubTitle>
//         <SubTitle>Action</SubTitle>
//       </HeadBox>
//       {[...selectedForSale, {}].map((item, i) => {
//         let salePrice = item?.salePrice ? item?.salePrice : item?.price || 0;
//         let discountAmount = 0;
//         let itemDiscount = item.saleDiscount
//           ? item.saleDiscount
//           : item.saleDiscount == ""
//             ? item.saleDiscount
//             : item.discount;
//         if (itemDiscount) {
//           let eachValue = (itemDiscount / 100) * salePrice;
//           discountAmount = Math.ceil(eachValue);
//         } else if (itemDiscount == "") {
//           discountAmount = 0;
//         } else {
//           discountAmount = 0;
//         }
//         let saleQty = item?.saleQuantity ? parseInt(item.saleQuantity) : 1;
//         let saleQuantity = item?.saleQuantity ?? 1;

//         item.saleQuantity ? parseInt(item.saleQuantity) : 1;
//         let itemPrice = 0;
//         let pr =
//           item.salePrice || item.salePrice == ""
//             ? parseInt(item.salePrice)
//             : parseInt(item.price);

//         if (item.gstAmount) {
//           itemPrice = Math.ceil((pr + item.gstAmount) * saleQty);
//         } else {
//           itemPrice = Math.ceil(pr * saleQty);
//         }

//         let TotalPrice = useMemo(() => {
//           if (itemDiscount) {
//             const itemDiscountPrice = (pr / 100) * itemDiscount;
//             const priceAfterDiscountPerUnit = pr - itemDiscountPrice;
//             return priceAfterDiscountPerUnit * saleQuantity;
//           } else {
//             return pr * saleQuantity;
//           }
//         }, [itemDiscount, pr, saleQuantity]);

//         return (
//           <Box sx={{ background: "#fff" }}>
//             <RowBox key={i} >
//               <Autocomplete
//                 size="small"
//                 fullWidth
//                 value={item}
//                 onChange={(e, val) => {
//                   handleItem(e, val);
//                 }}
//                 getOptionLabel={(option) => option?.name || ""}
//                 id="controllable-states-demo"
//                 options={inventory}
//                 renderInput={(params) => (
//                   <TextField
//                     placeholder={isMdDown ? "Select An Item" : ''}
//                     {...params}
//                     fullWidth
//                     variant="outlined"
//                     size="small"
//                   />
//                 )}
//               />

//               <TextField
//                 type="number"
//                 size="small"
//                 sx={{ mx: "2px" }}
//                 value={itemDiscount}
//                 onChange={(e) => handleEdit(e, i, "saleDiscount")}
//                 placeholder={isMdDown ? "Disc" : ''}
//                 disabled={item?._id ? false : true}
//               />

//               <TextField
//                 type="number"
//                 size="small"
//                 disabled={item?._id ? false : true}
//                 max={item?.quantity}
//                 sx={{ mx: "2px" }}
//                 value={item?._id ? saleQuantity : ""}
//                 onChange={(e) => handleEdit(e, i, "saleQuantity")}
//                 placeholder={isMdDown ? "Qty" : ''}
//               />

//               <Select
//                 variant="outlined"
//                 disabled={item?._id ? false : true}
//                 value={item?.unit || ""}
//                 name="unit"
//                 size="small"
//                 displayEmpty
//                 onChange={(e) => handleEdit(e, i, "unit")}
//               >
//                 <MenuItem value="">
//                   <em>{isMdDown ? "Select unit" : ""}</em>
//                 </MenuItem>
//                 {units.map((item, ind) => {
//                   return (
//                     <MenuItem key={ind} value={item}>
//                       {item}
//                     </MenuItem>
//                   );
//                 })}
//               </Select>
//               <TextField
//                 placeholder={isMdDown ? "Price" : ''}
//                 type="number"
//                 size="small"
//                 disabled={item?._id ? false : true}
//                 value={pr}
//                 sx={{ mx: "2px" }}
//                 onClick={(e) =>
//                   handleSalePrice(e.target.value, i, item?.costPrice)
//                 }
//                 onChange={(e) => handleEdit(e, i, "salePrice")}
//               />

//               <TextField
//                 placeholder={isMdDown ? "Total" : ''}
//                 size="small"
//                 disabled
//                 value={parseFloat(TotalPrice) || 0}
//               />

//               {item?._id && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "flex-end",
//                   }}
//                 >
//                   <img
//                     height="25px"
//                     style={{ cursor: "pointer" }}
//                     src={dustbin}
//                     alt="img"
//                     onClick={() => handleRemove(item._id, i)}
//                   />
//                 </Box>
//               )}
//             </RowBox>
//             {(bonus || item?.bonus) && (
//               <TextField
//                 size="small"
//                 variant="outlined"
//                 label="Bonus"
//                 sx={{ mt: "2px" }}
//                 value={item?.bonus || 0}
//                 onChange={(e) => handleEdit(e, i, "bonus")}
//               />
//             )}
//           </Box>
//         );
//       })}

//       {discModal && <AddDiscount onClose={discToggle} />}

//       <DialogComponent
//         title="Add Item"
//         open={addModal}
//         onClose={toggle}
//         dialogContent={<AddItem onClose={toggle} sale="true" />}
//       />
//     </Box>
//   );
// }

// export default TabOrderComponent;
